import React from 'react';
import {useTranslation} from 'react-i18next';
import UpdateUser from '../components/UpdateUser';
import Card from '../components/common/Card';
import PageHeader from '../components/common/header/PageHeader';

function SettingsPage(): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="l-container">
            <PageHeader title={t('navigation.settings')} />
            <Card header={t('settingsPage.userAccountSettings')}>
                <UpdateUser />
            </Card>
        </div>
    );
}

export default SettingsPage;
